import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LocationInputComponent } from "./location-input.component";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import {ExplanationLabelModule} from "../explanation-label/explanation-label.module";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import {CountryInputModule} from "../country-input/country-input.module";

@NgModule({
  declarations: [LocationInputComponent],
  imports: [
    CommonModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    NzSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    ExplanationLabelModule,
    NzIconModule,
    NzToolTipModule,
    CountryInputModule,
  ],
  exports: [
    LocationInputComponent
  ]
})
export class LocationInputModule {}
